import React from 'react';

import { useIntl } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';

import FilterAltOutlinedIcon from '@mui/icons-material/FilterAltOutlined';
import { ButtonType } from '@nhl/nhl-breakaway-ui';

import { filterActionCreators } from '~/redux/ducks/playersAndTeams/filter';
import Analytics from '~/utility/analytics';
import { commonMessages } from '~/utility/commonMessages';

import { IconButton } from './styles';

const AdvancedButton = React.memo(() => {
    const dispatch = useDispatch();
    const intl = useIntl();

    const areFiltersVisible = useSelector((state) => state.playersAndTeams.filter.isVisible);
    const appliedFilter = useSelector((state) => state.playersAndTeams.filter.applied);
    const appliedReport = useSelector((state) => state.playersAndTeams.report.applied);
    const franchiseData = useSelector((state) => state.config.franchiseData);

    const handleClick = (e) => {
        // Prevent the form from submitting
        e.preventDefault();
        dispatch(filterActionCreators.setFiltersVisibility(!areFiltersVisible));
        Analytics.sendGaReportEvent('more-filters', appliedReport, appliedFilter, franchiseData);
    };

    return (
        <IconButton
            variant={ButtonType.Secondary}
            onClick={handleClick}
            title={intl.formatMessage(commonMessages.labels.advanced)}
        >
            <FilterAltOutlinedIcon />
        </IconButton>
    );
});

export default AdvancedButton;
